export { fetchOutlets } from "./fetch-outlets";
